import React from 'react';
import ReportViewer from "./base/ReportViewer";

const AchalandageTypesLieuxSejour = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"AchalandageTypesLieuxSéjour"}/>
        </div>
    );
}
export default AchalandageTypesLieuxSejour;